export const getMonthlyPrice = (totalPrice: number) => {
  return Math.ceil((totalPrice / 12) * 100) / 100;
};
